import styled from 'react-emotion';

const TextOverflow = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export default TextOverflow;
